import React from 'react'
import Notificaton from '../../components/Account/Notificaton'

const Notifi = () => {
  return (
    <div>
        <Notificaton/> 
    </div>
  )
}

export default Notifi